import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/navbar/Navbar';
import Footer from '../../components/footer/Footer';
import Container from '../../components/Container';
import PageHeader from '../../components/PageHeader';
import TableOfContents from '../../components/TableOfContents';
import Prose from '../../components/Prose';

const LegalHubPage = () => {
  return (
    <div className="min-h-screen bg-[#f8f8f8]">
      <Navbar />
      
      <Container size="lg">
        <PageHeader
          eyebrow="Legal"
          title="Legal Information"
          description="Our policies, disclosures, and legal information to ensure transparency and compliance."
        />
        
        <div className="grid lg:grid-cols-4 gap-8 pb-16">
          <div className="lg:col-span-1">
            <TableOfContents />
          </div>
          
          <div className="lg:col-span-3">
            <Prose>
              <h2 id="privacy-policy">Privacy Policy</h2>
              <p>
                We are committed to protecting your privacy and handling your personal information 
                responsibly. Our privacy policy explains what information we collect, how we use it, 
                and your rights regarding your data.
              </p>
              <p>
                <Link to="/privacy" className="font-medium">Read our full Privacy Policy →</Link>
              </p>

              <h2 id="terms-of-service">Terms of Service</h2>
              <p>
                By using our website, you agree to our terms of service. These terms outline the 
                rules and regulations for using Radiance's website and services.
              </p>
              <p>
                <Link to="/terms" className="font-medium">Read our Terms of Service →</Link>
              </p>

              <h2 id="affiliate-disclosure">Affiliate Disclosure</h2>
              <p>
                Transparency is fundamental to our mission. We want you to know exactly how we operate 
                and how we may earn revenue from our recommendations.
              </p>
              <p>
                <Link to="/affiliate-disclosure" className="font-medium">Read our Affiliate Disclosure →</Link>
              </p>

              <h2 id="contact">Contact Information</h2>
              <p>
                If you have questions about any of our policies or need to contact us regarding 
                legal matters:
              </p>
              <ul>
                <li><strong>General Inquiries:</strong> <a href="mailto:hello@meetradiance.com">hello@meetradiance.com</a></li>
                <li><strong>Privacy Concerns:</strong> <a href="mailto:privacy@myradiance.ca">privacy@myradiance.ca</a></li>
                <li><strong>Legal Matters:</strong> <a href="mailto:legal@myradiance.ca">legal@myradiance.ca</a></li>
              </ul>
            </Prose>
          </div>
        </div>
      </Container>
      
      <Footer />
    </div>
  );
};

export default LegalHubPage;
